import { Card, CardContent } from '../ui/card';
import { Users, Trophy, Target } from 'lucide-react';

export const QuickStatsWidget = ({ stats }) => (
  <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    <Card className="stat-card card-hover" data-testid="stat-players">
      <CardContent className="p-4 sm:p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs sm:text-sm font-medium text-gray-500">Total Players</p>
            <p className="text-2xl sm:text-3xl font-bold text-gray-900 mt-1">{stats?.total_players || 0}</p>
          </div>
          <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-xl bg-blue-100 flex items-center justify-center">
            <Users className="w-5 h-5 sm:w-7 sm:h-7 text-blue-600" strokeWidth={1.5} />
          </div>
        </div>
      </CardContent>
    </Card>

    <Card className="stat-card card-hover" data-testid="stat-matches">
      <CardContent className="p-4 sm:p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs sm:text-sm font-medium text-gray-500">Matches Played</p>
            <p className="text-2xl sm:text-3xl font-bold text-gray-900 mt-1">{stats?.total_matches || 0}</p>
          </div>
          <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-xl bg-emerald-100 flex items-center justify-center">
            <Trophy className="w-5 h-5 sm:w-7 sm:h-7 text-emerald-600" strokeWidth={1.5} />
          </div>
        </div>
      </CardContent>
    </Card>

    <Card className="stat-card card-hover" data-testid="stat-goals-scored">
      <CardContent className="p-4 sm:p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs sm:text-sm font-medium text-gray-500">Goals Scored</p>
            <p className="text-2xl sm:text-3xl font-bold text-gray-900 mt-1">{stats?.goals_scored || 0}</p>
          </div>
          <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-xl bg-green-100 flex items-center justify-center">
            <Target className="w-5 h-5 sm:w-7 sm:h-7 text-green-600" strokeWidth={1.5} />
          </div>
        </div>
      </CardContent>
    </Card>

    <Card className="stat-card card-hover" data-testid="stat-goals-conceded">
      <CardContent className="p-4 sm:p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs sm:text-sm font-medium text-gray-500">Goals Conceded</p>
            <p className="text-2xl sm:text-3xl font-bold text-gray-900 mt-1">{stats?.goals_conceded || 0}</p>
          </div>
          <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-xl bg-red-100 flex items-center justify-center">
            <Target className="w-5 h-5 sm:w-7 sm:h-7 text-red-500" strokeWidth={1.5} />
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
);

export default QuickStatsWidget;
